import { useCallback } from 'react';
import {
    Easing,
    cancelAnimation,
    useAnimatedStyle,
    useSharedValue,
    withDelay,
    withRepeat,
    withSequence,
    withTiming,
} from 'react-native-reanimated';

import { useFocusEffect } from '@react-navigation/native';

const LIVE_INDICATOR_OFFSET = 12;
const DELAY_DURATION = 3200;
const TRANSLATE_DURATION = 300;

export const useLiveIndicatorAnimation = (indicatorWidth: number) => {
    const translationX = useSharedValue<number>(0);

    useFocusEffect(
        useCallback(() => {
            if (indicatorWidth === -1) {
                return;
            }
            const initialPosition = -indicatorWidth + LIVE_INDICATOR_OFFSET;
            const finalPosition = indicatorWidth - LIVE_INDICATOR_OFFSET;
            translationX.value = initialPosition;

            translationX.value = withRepeat(
                withSequence(
                    withDelay(
                        DELAY_DURATION,
                        withTiming(finalPosition, {
                            duration: TRANSLATE_DURATION,
                            easing: Easing.inOut(Easing.cubic),
                        })
                    ),
                    withTiming(initialPosition, {
                        duration: TRANSLATE_DURATION,
                        easing: Easing.inOut(Easing.cubic),
                    })
                ),
                -1
            );

            return () => {
                cancelAnimation(translationX);
                translationX.value = initialPosition;
            };
        }, [indicatorWidth, translationX])
    );

    return useAnimatedStyle(() => ({
        transform: [{ translateX: translationX.value }],
    }));
};
